module.exports = "/src/views/player/help/images/arena1.jpg";